import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=466eec78&"
import script from "./VideoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports